import { useEffect, useState } from "react";
import "./CuentaRegresiva.css";

export default function CuentaRegresiva() {
  const [tiempoRestante, setTiempoRestante] = useState({});

  useEffect(() => {
    const fechaBoda = new Date("2025-11-22T18:00:00"); // Fecha ajustada

    const interval = setInterval(() => {
      const ahora = new Date();
      const diferencia = fechaBoda - ahora;

      if (diferencia <= 0) {
        clearInterval(interval);
        setTiempoRestante(null);
        return;
      }

      const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
      const horas = Math.floor((diferencia / (1000 * 60 * 60)) % 24);
      const minutos = Math.floor((diferencia / (1000 * 60)) % 60);
      const segundos = Math.floor((diferencia / 1000) % 60);

      setTiempoRestante({ dias, horas, minutos, segundos });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="cuenta-regresiva seccion">
      {tiempoRestante ? (
        <div className="contenedor-cuenta">
          <h2>Nos Casamos</h2>
          <div className="tiempo">
            <div>
              <span>{tiempoRestante.dias ?? "--"}</span>
              <small>días</small>
              <span className="dos-puntos">:</span>
            </div>
            <div>
              <span>{tiempoRestante.horas ?? "--"}</span>
              <small>horas</small>
              <span className="dos-puntos">:</span>
            </div>
            <div>
              <span>{tiempoRestante.minutos ?? "--"}</span>
              <small>minutos</small>
              <span className="dos-puntos">:</span>
            </div>
            <div>
              <span>{tiempoRestante.segundos ?? "--"}</span>
              <small>segundos</small>
            </div>
          </div>
        </div>
      ) : (
        <h2>¡Nos casamos!</h2>
      )}
    </section>
  );
}
